export const tlosPrice = ({ tlosPrice }) => tlosPrice;
export const gasPrice = ({ gasPrice }) => gasPrice;
export const latestBlock = ({ latestBlock }) => latestBlock;
